var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.path || _vm.href)?_c('a',{attrs:{"href":_vm.finalLink,"target":_vm.target}},[_c('div',{staticClass:"box"},[_c('h3',{staticClass:"title"},[_vm._v(_vm._s(_vm.panel.title)+" ")])])]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }